(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gifting-page-content"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    const giftingNavItems = document.querySelectorAll('.gifting-nav__item')
    const giftingFilterButtons = document.querySelectorAll('.gifting-filter__button')

    const scrollToCollection = (target, collectionTitle) => {
      window.location = `#${target}`
    }

    giftingNavItems.forEach(function (button) {
      const parent = button.closest('.gifting-nav__item')
      const collectionId = parent.dataset.collectionId
      const collectionTitle = parent.dataset.collectionTitle
      button.addEventListener('click', () => scrollToCollection(collectionId, collectionTitle))
    })

    const handleFilterProducts = (button) => {
      const priceFilterMin = parseInt(button.dataset.priceFilterMin)
      const priceFilterMax = parseInt(button.dataset.priceFilterMax)
      const productsOnPage = document.querySelectorAll('rebuilt-product-card')
      productsOnPage.forEach(function (product) {
        const productPrice = parseInt(product.dataset.productPriceInCents)
        if (!productPrice) {
          return
        }
        product.classList.add('hidden')
        if (productPrice >= priceFilterMin && productPrice <= priceFilterMax) {
          product.classList.remove('hidden')
        }
      })

      giftingFilterButtons.forEach((btn) => {
        btn.classList.remove('active')
      })
      button.classList.add('active')

      // hide row completedly if no products are visible
      document.querySelectorAll('.product-slider__grid').forEach((row) => {
        const productsInRow = row.querySelectorAll('rebuilt-product-card')
        const productsVisible = Array.from(productsInRow).filter(
          (product) => !product.classList.contains('hidden'),
        )
        if (productsVisible.length === 0) {
          row.classList.add('hidden')
        } else {
          row.classList.remove('hidden')
        }
      })
    }

    giftingFilterButtons.forEach(function (button) {
      button.addEventListener('click', () => handleFilterProducts(button))
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pillar-cards"] && !Shopify.designMode) return;
  try {
    
  class PillarCards extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.init()
    }

    init() {
      const swiperElement = this.querySelector('.swiper.pillar-cards__items')
      if (!swiperElement) return
      const swiper = new Swiper(swiperElement, {
        slidesPerView: 1.2,
        spaceBetween: 20,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        breakpoints: {
          500: {
            slidesPerView: 1.5,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
          },
          768: {
            slidesPerView: 2.2,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
          },
          992: {
            slidesPerView: 3,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
      })
    }
  }

  customElements.define('pillar-cards', PillarCards)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-secret-gwp-promos"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    if (!customElements.get('secret-gwp-promo-item')) {
      customElements.define(
        'secret-gwp-promo-item',
        class SecretGwpPromoItem extends HTMLElement {
          constructor() {
            super()
            const itemUtmKey = this.getAttribute('data-utm-key')
            const sgwp = getCookie('tc_secret_gift')
            const tc_secret_gift_expiration = getCookie('tc_secret_gift_expiration')
            const countdownTimerWrap = this.querySelector('countdown-timer-wrap')
            if (
              countdownTimerWrap !== null &&
              tc_secret_gift_expiration !== null &&
              tc_secret_gift_expiration !== ''
            ) {
              countdownTimerWrap.innerHTML = `<countdown-timer data-text-before="Offer Expires in " data-timestamp="${tc_secret_gift_expiration}">Offer Expires in 00:00:00</countdown-timer>`
            }
            if (itemUtmKey === null) {
              return
            }
            let paramEligible = false
            if (sgwp !== null && itemUtmKey.toLowerCase() === sgwp.toLowerCase()) {
              paramEligible = true
            }
            if (paramEligible) {
              this.style.display = 'block'
            } else {
              this.remove()
            }
          }
        },
      )
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
